import { useState } from 'react';
import { View } from 'react-native';
import { colors } from '@hogar/shared';
import { Button, ErrorText, Field, Label, Screen, Segmented, Txt, useT } from '../components/ui';
import { LanguagePicker } from '../components/LanguagePicker';
import { Logo } from '../components/Logo';
import { api } from '../lib/api';
import { useAction, useSession } from '../lib/session';
import { useHouse } from '../lib/house';

/** First visit of an invited second owner: the house is ready, only their name is missing. */
export default function WelcomeName() {
  const { t, lang } = useT();
  const { setLang } = useSession();
  const { household } = useHouse();
  const act = useAction();
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const save = async () => {
    try {
      await act(() => api('PATCH', '/me', { name: name.trim(), lang }));
    } catch {
      setError(t('errGeneric'));
    }
  };

  return (
    <Screen>
      <View style={{ alignItems: 'center', marginVertical: 28 }}>
        <Logo />
      </View>
      <Txt weight="semibold" size={24}>
        {t('welcomeJoin', { house: household.name })}
      </Txt>
      <Txt color={colors.textMuted} style={{ marginTop: 4 }}>
        {t('welcomeJoinSub')}
      </Txt>
      <Label>{t('language')}</Label>
      <LanguagePicker value={lang} options={['es', 'en'] as const} onChange={setLang} />
      <Label>{t('yourName')}</Label>
      <Field value={name} onChange={setName} autoComplete="name" autoFocus onSubmit={save} />
      <ErrorText>{error}</ErrorText>
      <Button label={t('continue')} onPress={save} disabled={!name.trim()} style={{ marginTop: 22 }} />
    </Screen>
  );
}
